import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 2rem 0;
  font-size: 10px;

  > p {

    > a {
      color: #9aa4bf80;
      text-decoration: none;
    }
  }


  /* MOBILE */
  @media (max-width: 376px) {
    font-size: 8.5px !important;
  }
`;
